module.exports = __webpack_public_path__ + "static/media/womp.3e73ec12.svg";